import React from "react";
import { useState,useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/SuspendedPaymentReport.css';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import Loading from './Loading';
import { format } from "date-fns";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
//import SalespersonSidebar from "./SalespersonSidebar";


const columns = [   
    {
        field: 'order_id',
        headerName: 'Order ID',
        cellClassName:'order_id_column',headerClassName:'order_id_header',  
        flex:1, 
        minWidth: 57, 
        sortable:false,
    },  
        {
        field: 'email',
        headerName: 'Email',
        flex:1,
        sortable: false,
        minWidth:220,
        cellClassName:'email_column',headerClassName:'email_header', 
         renderCell: (params) => (
        <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.email}
          </Link>
      ),
        
      },
      {
        field: 'phone',
        headerName: 'Phone',
        cellClassName:'phone_column',headerClassName:'phone_header',  
        flex:1, 
        minWidth: 100, 
        sortable:false,
    },
    {
        field: 'salesperson',
        headerName: 'Salesperson',
        cellClassName:'salesperson_column',headerClassName:'salesperson_header',  
        flex:1, 
        // minWidth: 83, 
         minWidth: 95, 
        sortable:false,
    },
    {
        field: 'product',
        headerName: 'Product',
        cellClassName:'product_column',headerClassName:'product_header',  
        flex:1, 
        minWidth: 300, 
        sortable:false,
    },
    
    {
        field: 'subscription_status',
        headerName: 'Subscription Status',
        cellClassName:'subscription_status_column',headerClassName:'subscription_status_header',  
        flex:1, 
        minWidth: 70,        
        sortable:false,
    },
    {
        field: 'due_date',
        headerName: 'Due date',
        cellClassName:'due_date_column',headerClassName:'due_date_header',  
        flex:1, 
        minWidth: 81, 
        sortable:false,
    },  
    {
        field: 'amount_due',
        headerName: 'Amount Due',
        cellClassName:'amount_due_column',headerClassName:'amount_due_header',  
        flex:1, 
        minWidth: 68, 
        sortable:false,
    },  
  
];




const SuspendedPaymentReport = () => { 
    // const initialForm = {     
              
    //     start_date:'',
    //     start_date_obj: null,
    //     end_date:'',
    //     end_date_obj: null,
    //     courses:[],
    //     sub_status:'Suspended'        
    // };

    const initialForm = () => {
    const params = new URLSearchParams(window.location.search);

    const defaultForm = {
        start_date:'',
        end_date:'',
        start_date_obj:null,
        end_date_obj:null,
        courses:[],
        sub_status:'Suspended',
        action: '',
    };

    //  normal dates
    const queryStart = params.get("start_date");
    const queryEnd = params.get("end_date");

    // const startObj = queryStart && !isNaN(new Date(queryStart))
    //     ? new Date(queryStart + "T00:00:00")
    //     : null;

    // const endObj = queryEnd && !isNaN(new Date(queryEnd))
    //     ? new Date(queryEnd + "T00:00:00")
    //     : null;

    const startObj =
        queryStart
        ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
        : null;

    const endObj =
        queryEnd
        ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
        : null;

    // const queryView = params.get("view") || ''; 

    // const courses = (() => {
    //     if (!params.has("courses")) return defaultForm.courses; 

    //     const allCourses = params.getAll("courses");
    //     if (allCourses.length > 1) return allCourses;  
    //     return allCourses[0].split(",");
    // })();
    // const courses = (() => {
    //     if (!params.has("courses")) return [];

    //     const allCourses = params.getAll("courses");

    //     if (allCourses.length > 1) {
    //         return allCourses.filter(Boolean); 
    //     }

    //     if (allCourses.length === 1) {
    //         if (!allCourses[0]) return []; 

    //         return allCourses[0]
    //         .split(",")
    //         .filter(Boolean); 
    //     }

    //     return [];
    // })();
    const courses = (() => {
    const values = [];

    for (const [key, value] of params.entries()) {
        if (key.startsWith("courses[")) {
        if (value) values.push(value);
        }
    }

    return values;
    })();

    return {
        ...defaultForm,
        courses: courses,
        sub_status: params.get("sub_status") || defaultForm.sub_status,

        //  normal dates
        start_date: startObj ? queryStart : '',
        start_date_obj: startObj,

        end_date: endObj ? queryEnd : '',
        end_date_obj: endObj,

        // view: queryView,
        action: '',
    };
    };

    const startDateRef = useRef(null);
    const endDateRef = useRef(null);

    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState(initialForm());
    const [appliedFormData, setAppliedFormData] = useState(initialForm());
    const [formErrors, setFormErrors] =useState({});
    const[productList, setProductList] = useState({});
    const [submittedData, setSubmittedData] = useState(null);  
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const[totalAmount, setTotalAmount] = useState(0);
    const app_url = configData.APP_URL;
    const [isSubmitted, setIsSubmitted] = useState(false); 
    
  
    
//   const handleDateChange = (name, date) => {
//     const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
//     setFormData((prev) => ({
//       ...prev,
//       [name]: formattedDate
//     }));
//   };
    const handleDateChange = (date, field) => {
    setFormData(prev => ({
        ...prev,
        [`${field}_obj`]: date,                   
        [field]: date ? format(date, 'yyyy-MM-dd') : '' 
    }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
 const handleCoursesChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, courses: selectedValues }));
    };
    // useEffect(() => { 
    //      getcourselist();       
    //     const timer = setTimeout(() => {
    //         setIsLoading(false);
    //     }, 1000); 

    //     return () => clearTimeout(timer); 
     
    // },[]); 
    useEffect(() => { 
        Promise.all([
            getcourselist()
        ]).then(() => {
        setIsLoading(false);
        })
    },[]); 
    
   React.useEffect(() => {
          if(formData.start_date && formData.end_date) {
              const fetchData = async () => {
              // Simulate API call to your server
               // In a real application, replace this with your actual fetch logic
         try {
          setIsLoading(true);
        const response = await fetch(app_url+'report/suspendedpayment', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sortModel,
            filterModel,
            // formData:formData
            formData: {
                ...appliedFormData,
                action: isSubmitted ? 'submit' : ''
            }
          }),
        });
        const data = await response.json();
        console.log(data.data.rows);
        setRows(data.data.rows);
        setRowCount(data.data.totalRowCount); // Server should return totalRowCount
        setTotalAmount(data.data.totalpayment);
        }  catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
                if (isSubmitted) {
                setIsSubmitted(false);
                }
            }
            
      };
      
  
      fetchData();
    }
        }, [paginationModel, sortModel, filterModel, appliedFormData]); // Re-fetch data when these change 
    const validateDates = (formData) => {
    let errors = {};

    if (!formData.start_date) {
        errors.start_date = "Start date is required.";
    }

    if (!formData.end_date) {
        errors.end_date = "End date is required.";
    }

    if (formData.start_date && formData.end_date) {
        if (formData.end_date < formData.start_date) {
        errors.end_date = "Start date can't over end date.";
        }
    }

    return errors;
    };
  
    const submitFormData = async (data) => {
        setSubmittedData(data);
        setAppliedFormData(data);
        setIsSubmitted(false);
    };

      const handleSubmit = async (e) => {
          e.preventDefault(); // stop page reload
           const errors = validateDates(formData);

            if (Object.keys(errors).length > 0) {
                console.log("Validation errors:", errors);
                setFormErrors(errors); 
                return;
            }
            setFormErrors({});
            setPaginationModel({
                page: 0,
                pageSize: 50,
            });
            setSubmittedData(formData);
            setAppliedFormData({...formData});
            setIsSubmitted(true);
 
    //    try {
    //       setIsLoading(true);
    //     const response = await fetch(app_url+'report/suspendedpayment', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify({
    //         page: 0,
    //         pageSize: 50,
    //         sortModel,
    //         filterModel,
    //         formData:formData
    //       }),
    //     });
    //     const data = await response.json();
      
    //     setRows(data.data.rows);
    //     setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    //      setTotalAmount(data.data.totalpayment);
    //     }  catch (error) {
    //           console.error('Error fetching data:', error);
    //         } finally {
    //           setIsLoading(false); // Set loading to false after fetch completes (success or error)
    //         }
     
      
    };

    // useEffect(() => {
    //     const params = new URLSearchParams(window.location.search);

    //     if ([...params.keys()].length > 0) {
    //     const init = initialForm();

    //     setFormData(init);

    //     submitFormData(init);
    //     }
    // }, []);
  
   const handleExport = async (e) => {
    e.preventDefault(); // stop page reload
     const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
        console.log("Validation errors:", errors);
        setFormErrors(errors); 
        return;
    }
    setFormErrors({});
   
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'report/suspendedpaymentexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          
          formData:formData
        }),
      });
      const data = await response.json();
       const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };
   async function getcourselist() {
        try { 
            const response = await fetch(
                app_url+'smwwcommerceproduct/getsuspendedreportproductlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setProductList(responsedata.data.result);
                
               
            } 
        } catch (err) {
            
        }    
    }
    const normalizeBackendData = (backendParams) => {
      return {
        ...backendParams,
    
        start_date_obj: backendParams.start_date
          ? new Date(backendParams.start_date.replace(/-/g, "/") + " 00:00:00")
          : null,
    
        end_date_obj: backendParams.end_date
          ? new Date(backendParams.end_date.replace(/-/g, "/") + " 00:00:00")
          : null,
      };
    };
    
    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const reportViewId = params.get("report_view_id");
    
      const baseForm = initialForm(); 
    
      if (reportViewId) {
        const fetchData = async () => {
          try {
            const res = await fetch(app_url + 'report/getreportfilters', {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ id: reportViewId }),
            });
    
            const data = await res.json();
            const backendParams = data?.data?.params || {};
    
            //  normalize backend
            const normalized = normalizeBackendData(backendParams);
    
            //  merge (backend overrides URL/defaults)
            const finalData = {
              ...baseForm,
              ...normalized,
            };
    
            setFormData(finalData);
            submitFormData(finalData);
    
          } catch (err) {
            console.error(err);
          }
        };
    
        fetchData();
      } else {
        //  fallback → only URL/default
        if ([...params.keys()].length > 0) {
          setFormData(baseForm);
          submitFormData(baseForm);
        }
      }
    
    }, []);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main" className="suspended-payment-report-main">
                    <Helmet><title>Suspended Payment</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <h1 style={{marginLeft: "6px"}}>Suspended Payment</h1>
                        <div className="suspended-payment-container">
                      <div className="messages warning">
                        <strong>This report includes:</strong><br/>
                        &nbsp;&nbsp;- Data available starting January 2017.<br/>
                        &nbsp;&nbsp;- If you're looking up large amounts of data, please wait for the report to load.<br/>
                        &nbsp;&nbsp;- If your search is not successful (i.e. system crashes), try narrowing the search.<br/>                      
                    </div>
                  <div className="messages_details">
                    <ul>
                        <li><strong>For old/past date range --&gt; Pending:</strong> The subscription's payment date has passed, but the payment has not been made nor has it been declined.</li>
                        <li><strong>For future date range --&gt; Pending:</strong> The subscription has not been paid, but the payment date has not lapsed.</li>

                    </ul>	
                    </div>
                            <form onSubmit={handleSubmit}>
                                <fieldset style={{border:0}}>                                  
                                  
                                    <div className="suspended-payment-flex">
                                        <div>
                                             <label htmlFor="start_date">Start Date:</label>
                                           
                                            <DatePicker
                                                ref={startDateRef}
                                                // selected={
                                                // formData.start_date
                                                //     ? new Date(formData.start_date)
                                                //     : null
                                                // }
                                                selected={formData.start_date_obj}
                                                onChange={(date) => {
                                                handleDateChange(date, "start_date");
                                                setTimeout(() => {
                                                    const input = startDateRef.current?.input;
                                                    if (input) {
                                                    const len = input.value.length;
                                                    input.setSelectionRange(len, len);
                                                    }
                                                }, 0);
                                                }}
                                                name="start_date"
                                                id="pay_start_date"
                                                // required
                                            /> 
                                                {formErrors.start_date && (
                                                <div className="error">{formErrors.start_date}</div>
                                                )} 
                                            <br /><br />
                                            <label htmlFor="end_date">End Date:</label>
                                          
                                            <DatePicker
                                                ref={endDateRef}
                                                // selected={
                                                // formData.end_date
                                                //     ? new Date(formData.end_date)
                                                //     : null
                                                // }
                                                selected={formData.end_date_obj}
                                                onChange={(date) => {
                                                handleDateChange(date, "end_date");
                                                setTimeout(() => {
                                                    const input = endDateRef.current?.input;
                                                    if (input) {
                                                    const len = input.value.length;
                                                    input.setSelectionRange(len, len);
                                                    }
                                                }, 0);
                                                }}
                                                name="end_date"
                                                id="pay_end_date"
                                                // required
                                            />
                                            	  {formErrors.end_date && (
                                                <div className="error">{formErrors.end_date}</div>
                                                )}
                                            <br /><br />
                                        </div>
                                           <div>
                                            <label>Products:</label>
                                           <select 
                                                name="courses" 
                                                size="15" 
                                                className="product-select"
                                                multiple
                                                onChange={handleCoursesChange}
                                                value={formData.courses}
                                            >

                                                {productList.length > 0 && (
                                                    <>
                                                        {productList.map((item, index) => {
                                                            return <>
                                                               
                                                                <><option value={item['sku']}>{item['name']}</option></>
                                                               
                                                            </>
                                                        })}  
                                                    </>
                                                )}
                                            </select>
                                            <div style={{marginTop:"10px"}}>*To select more than one product, hold the Command/Ctrl key and click on as many as you want.</div>
                                        </div>         
                                        <div>
                                            <br />
                                        <div>
                                            <label>Subscription Status</label>
                                            <select name="sub_status" class="form-select" value={formData.sub_status} onChange={handleChange}>
                                            <option value="Suspended" selected="">Suspended</option>
                                            <option value="Pending">Pending</option>
                                            </select>
                                        </div>                                      
                                      
                                        <div style={{marginTop: "15px"}}>
                                            <input type="submit" name="" value="submit" className="form-submit" style={{marginRight: "5px"}} />&nbsp; 
                                            <input type="button" name="" value="export" className="form-submit" onClick={handleExport} />&nbsp;
                                            
                                        </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                             {submittedData && (
                                <>
                            <div className="totals-container">
                            
                                <div id="total_apps"style={{padding: "25px", marginRight:"1%"}}><strong>Total</strong>: {totalAmount}</div>
                          
                            </div>
        

                            <div className="suspended-payment-popupdata">
                                <div className="suspended-payment-content">
                                    <table className="suspended-payment-table">
                                        <div>
                                            <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                rowCount={rowCount}
                                                paginationMode="server"
                                                sortingMode="server"
                                                filterMode="server"
                                                paginationModel={paginationModel}
                                                onPaginationModelChange={setPaginationModel}
                                                sortModel={sortModel}
                                                onSortModelChange={setSortModel}
                                                filterModel={filterModel}
                                                onFilterModelChange={setFilterModel}
                                                pageSizeOptions={[5, 10, 25,50]}
                                                getRowId={() => crypto.randomUUID()}
                                                getRowHeight={() => 'auto'}
                                                disableColumnFilter 
                                                // disableColumnResize={true}
                                            />
                                        </div>
                                    </table>
                                </div>
                            </div>
                      </>
)}
                        </div>
                    </div>
                    <div className="right">
                        {/* <SalespersonSidebar/> */}
                    </div>
                </div>
            )}
        </>
    );
};
export default SuspendedPaymentReport;